import React from 'react';
import PropTypes from 'prop-types';
import { getBaseUrl } from '../config/api';

const AdjuntosList = ({ adjuntos }) => {
    const baseUrl = getBaseUrl();
    return (
        <div>
            <h3>Archivos adjuntos</h3>
            <ul style={{ listStyle: 'none', padding: 0 }}>
                {adjuntos.map((archivo) => {
                    const url = `${baseUrl}/uploads/tickets/${archivo.nombre_archivo}`;

                    return (
                        <li key={archivo.nombre_archivo} style={{ marginBottom: '12px' }}>
                            <a href={url} target="_blank" rel="noopener noreferrer">
                                     {archivo.nombre_archivo}
                                </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

AdjuntosList.propTypes = {
  adjuntos: PropTypes.array.isRequired,
};

export default AdjuntosList;
